<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    d-add(ref="dialogAdd" :customer-id="customerId" :ad-group-id="adGroupId" @complele="doLoadAds(true)")
    d-copy(ref="dialogCopy" :customer-id="customerId" :ad-selecteds="itemSelecteds")

    v-layout(column)
      v-flex.mb-3
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") autorenew
            v-flex
              .headline Ads
              .overline {{ adGroupId }}
          v-flex(d-flex justify-end align-center)
            v-btn.mr-2(@click="doLoadAds(true)") Refersh
            v-btn.mr-2(:disabled="!itemSelecteds.length" @click="$refs.dialogCopy.show()") Copy
            v-btn(@click="$refs.dialogAdd.show()") Add Ad

      v-flex(fill-height)
        v-card
          v-data-table(
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="15"
            item-key="adGroupAd.resourceName"
            v-model="itemSelecteds"
            show-select
          )
            template(v-slot:item.preview="{ item }")
              .preview(:class="getAdView(item, 'class')")
                .head {{ getAdView(item, 'head') }}
                .path {{ getAdView(item, 'path') }}
                .desc {{ getAdView(item, 'desc') }}
</template>

<script>
import { mapActions } from 'vuex'
import DAdd from './dialogs/AddAdGroupAd'
import DCopy from './dialogs/CopyAdGroupAd'

export default {
  components: {
    DAdd,
    DCopy
  },
  data () {
    return {
      customerId: null,
      campaignId: null,
      adGroupId: null,
      loading: false,
      items: [],
      itemSelecteds: [],
      headers: [
        // { text: 'Ad', value: 'adGroupAd.ad.id' },
        { text: 'Preview', value: 'preview' },
        { text: 'Status', value: 'adGroupAd.status' },
        { text: 'Type', value: 'adGroupAd.ad.type' },
        { text: 'Clicks', value: 'metrics.clicks' },
        { text: 'Impr.', value: 'metrics.impressions' },
        { text: 'CTR', value: 'metrics.ctr' },
        { text: 'Avg. CPC', value: 'metrics.averageCpc' },
        { text: 'Cost', value: 'metrics.costMicros' }
      ]
    }
  },
  async mounted () {
    this.customerId = this.$route.params.customer
    this.campaignId = this.$route.params.campaign
    this.adGroupId = this.$route.params.adgroup
    this.doLoadAds()
  },
  methods: {
    ...mapActions({
      loadAdGroupAds: 'ads/loadAdGroupAds'
    }),
    getAdView (item, attr) {
      const ad = item.adGroupAd.ad || {}
      switch (ad.type) {
        case 'EXPANDED_TEXT_AD':
          return this.getExpandedView(item, attr)
        case 'RESPONSIVE_SEARCH_AD':
          return this.getResponsiveView(item, attr)
      }
    },
    getExpandedView (item, attr) {
      const ad = item.adGroupAd.ad || {}
      const val = ad.expandedTextAd

      let result = null
      let delimiter = '. '
      switch (attr) {
        case 'class':
          result = 'expanded-text-ad'
          break
        case 'head':
          result = [val.headlinePart1, val.headlinePart2, val.headlinePart3]
          delimiter = ' | '
          break
        case 'desc':
          result = [val.description, val.description2]
          break
        case 'path':
          result = [ad.finalUrls[0], val.path1, val.path2]
          delimiter = '/'
          break
      }

      return (result instanceof Array)
        ? result.filter(r => r).join(delimiter)
        : result
    },
    getResponsiveView (item, attr) {
      const ad = item.adGroupAd.ad || {}
      const val = ad.responsiveSearchAd

      let result = null
      let delimiter = '. '
      switch (attr) {
        case 'class':
          result = 'responsive-search-ad'
          break
        case 'head':
          result = val.headlines.map(d => d.text)
          delimiter = ' | '
          break
        case 'desc':
          result = val.descriptions.map(d => d.text)
          break
        case 'path':
          result = [ad.finalUrls[0], val.path1, val.path2]
          delimiter = '/'
          break
      }

      return (result instanceof Array)
        ? result.filter(r => r).join(delimiter)
        : result
    },
    async doLoadAds (reload = false) {
      if (this.customerId && this.adGroupId) {
        const params = {
          customerId: this.customerId,
          campaignId: this.campaignId,
          adGroupId: this.adGroupId,
          reload: reload
        }
        this.loading = true
        this.items = await this.loadAdGroupAds(params)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-data-table
  .preview
    margin: 10px 0
    padding: 10px
    border: thin solid #ede

    > .head
      color: #1a0dab

    > .path
      font-size: 0.9rem
      color: green

    > .desc
      font-size: 0.9rem
</style>
